import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource-variable/source-serif-4/opsz.css";
import "@fontsource-variable/inter-tight/index.css";
import { App } from "./App.tsx";
import { applyTheme, storedTheme } from "./lib/theme.ts";
import "./styles.css";

// Set the saved theme before the first render so a dark-mode choice doesn't flash light.
applyTheme(storedTheme());

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
